import { render, staticRenderFns } from "./WholesalersList.vue?vue&type=template&id=725ab7e1&scoped=true&"
import script from "./WholesalersList.vue?vue&type=script&lang=js&"
export * from "./WholesalersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725ab7e1",
  null
  
)

export default component.exports